module.exports = __webpack_public_path__ + "static/road-16397dfeab942599a280e83ed044e65a.png";